<template>
	<div class="k-page-content">
		<el-tabs v-model="activeName" class="box-eltab">
			<el-tab-pane label="退款申请" name="first">
				<div class="k-page-common">
					<div class="k-common-header">
						<div class="k-filter-option k-filter-input" style="margin-bottom:0;">
							<el-form :inline="true" :model="searchForm" size="mini" ref="searchForm">
								<el-form-item label="退款编码">
									<el-input v-model="searchForm.refund_code" placeholder="请填写退款编码" clearable></el-input>
								</el-form-item>
								<el-form-item label="项目编码" v-if="turntypeName == 'second'">
									<el-input v-model="searchForm.project_code" placeholder="请填写项目编码" clearable></el-input>
								</el-form-item>
								<el-form-item label="执行编码" v-if="turntypeName == 'first'">
									<el-input v-model="searchForm.execute_code" placeholder="请填写执行编码" clearable></el-input>
								</el-form-item>
								<el-form-item label="所属平台" v-if="turntypeName == 'first'">
									<el-select v-model="searchForm.platform_id" placeholder="请选择所属平台" clearable>
										<el-option v-for="item in options.platform_id_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="平台单号" v-if="turntypeName == 'first'">
									<el-input v-model="searchForm.plarfotm_order" placeholder="请填写平台单号" clearable></el-input>
								</el-form-item>
								<el-form-item label="退款类型" v-if="turntypeName == 'first'">
									<el-select v-model="searchForm.refund_type" placeholder="请选择退款类型" clearable>
										<el-option label="供应商退款" :value="1"></el-option>
										<el-option label="平台退款" :value="2"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="退款账户" v-if="turntypeName == 'first'">
									<el-select v-model="searchForm.refund_method" placeholder="请选择退款账户类型" clearable>
										<el-option label="银行账户" :value="1"></el-option>
										<el-option label="系统账户" :value="2"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="核销状态" v-if="turntypeName == 'first'">
									<el-select v-model="searchForm.off_status" placeholder="请选择核销类型" clearable>
										<el-option label="其他" :value="0"></el-option>
										<el-option label="冻结" :value="1"></el-option>
										<el-option label="核销" :value="2"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="抵扣状态" v-if="turntypeName == 'first'">
									<el-select v-model="searchForm.dikou_type" placeholder="请选择抵扣状态" clearable>
										<el-option label="未抵扣" :value="1"></el-option>
										<el-option label="部分抵扣" :value="2"></el-option>
										<el-option label="全部抵扣" :value="3"></el-option>
										<el-option label="--" :value="4"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="退款状态">
									<el-select v-model="searchForm.status" placeholder="请选择退款状态" clearable>
										<el-option v-for="item in options.status_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="申请日期">
									<el-date-picker v-model="searchForm.create_time" type="daterange" format="yyyy-MM-dd"
										value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
									</el-date-picker>
								</el-form-item>
								<el-form-item label="退款日期">
									<el-date-picker v-model="searchForm.refund_date" type="daterange" format="yyyy-MM-dd"
										value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
									</el-date-picker>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" icon="el-icon-search" @click="doSearch">查询</el-button>
									<el-button type="primary" icon="el-icon-refresh" @click="reset">重置</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
					<div class="k-common-con">
						<div class="k-table-wrapper">
							<div class="resourceHandleTop">
								<el-tabs v-model="turntypeName" @tab-click="handleCheckClick">
									<el-tab-pane label="供应商/平台退款" name="first"></el-tab-pane>
									<el-tab-pane label="客户退款" name="second"></el-tab-pane>
								</el-tabs>
								<div class="btn">
									<el-button type="primary" size="mini" @click="addTurnOpen"
										v-if="$parent.$parent.isAuthAction('admin/customers/customer/craterefundrequest')">退款申请</el-button>
								</div>
								<div class="btn_d" v-if="turntypeName == 'first'">
									<el-link type="primary" :disabled="isDownloading" icon="el-icon-download" @click="exportData"
										v-if="$parent.$parent.isAuthAction('admin/customers/export/exportrefundexcel')">{{
											isDownloading ? '下载中...' : '下载' }}</el-link>
								</div>
							</div>
							<div class="k-table-con">
								<template v-if="turntypeName == 'first'">
									<el-table :key="1" :data="tableData.data" style="width: 100%" border stripe ref="table1"
										highlight-current-row v-loading="loading" @sort-change="sortChange" :height="tableHeight">
										<el-table-column prop="id" fixed label="ID" align="center" width="55">
										</el-table-column>
										<el-table-column prop="refund_code" label="退款编码" fixed width="200">
											<template slot-scope="scope">
												<el-link type="primary" style="font-size: 12px; text-decoration: underline;" :underline="false"
													@click="detail(scope.row)" target="_blank">{{ scope.row.refund_code }}</el-link>
											</template>
										</el-table-column>
										<el-table-column prop="execute_code" label="退款执行编码" width="240">
										</el-table-column>
										<el-table-column prop="type_txt" label="退款类型" width="100">
										</el-table-column>
										<el-table-column prop="refund_method_txt" label="退款账户" width="100">
										</el-table-column>
										<el-table-column label="退款抵扣详情" width="150">
											<template slot-scope="scope">
												<p style="font-weight: bold;">退 款:&nbsp;{{ scope.row.amount_txt }}</p>
												<p style="font-weight: bold;">已 抵:&nbsp;{{ scope.row.yidikou_txt }}</p>
												<p style="font-weight: bold;color:#F56C6C;">剩 余:&nbsp;{{ scope.row.shengyukedikou_txt }}</p>
											</template>
										</el-table-column>
										<el-table-column prop="off_balance_txt" label="核销信息" width="120">
											<template slot-scope="scope">
												<template v-if="scope.row.off_balance_txt != '--'">
													<el-popover placement="top" width="400" trigger="hover">
														<div class="yhLine">
															<p style="font-weight: bold;">核销详情:</p>
															<p>核销人员：{{ scope.row.wid_txt }}</p>
															<p>核销时间：{{ scope.row.off_time }}</p>
															<p>核销备注：{{ scope.row.off_txt }}</p>
															<p>核销附件：
																<template v-for="(fit, index) in scope.row.img_txt">
																	<el-link type="primary" :href="fit" target="_blank" rel="noopener noreferrer">附件{{
																		index + 1 }}</el-link>{{ index ==
																			scope.row.img_txt.length - 1 ? '' : '、' }}
																</template>
															</p>
														</div>
														<p style="font-weight: bold;color: #409EFF;" slot="reference">
															金额:&nbsp;{{ scope.row.off_balance_txt }}</p>
													</el-popover>
													<p style="font-weight: bold;color: #303133;" v-if="scope.row.off_status_txt">
														状态:&nbsp;{{ scope.row.off_status_txt }}
													</p>
												</template>
												<p style="font-weight: bold;" v-else>{{ scope.row.off_balance_txt }}</p>

											</template>
										</el-table-column>
										<el-table-column fixed="right" prop="refund_status" label="抵扣状态" align="center" width="80">
											<template slot-scope="scope">
												<span style="font-weight: bold;">{{ scope.row.refund_status }}</span>
											</template>
										</el-table-column>
										<el-table-column prop="is_cancel_execute_txt" label="取消执行" width="80">
										</el-table-column>
										<el-table-column prop="platform_txt" label="所属平台" width="80">
										</el-table-column>
										<el-table-column prop="is_plarfotm_order_txt" label="平台下单" width="80">
										</el-table-column>
										<el-table-column prop="plarfotm_order" label="平台单号" width="120" show-overflow-tooltip>
										</el-table-column>
										<el-table-column prop="plarfotm_order" label="收款/退款详情" width="400" show-overflow-tooltip>
											<template slot-scope="scope">
												<div>
													<el-popover placement="top" width="400" v-if="scope.row.collect_name != '--'" trigger="hover">
														<div class="yhLine">
															<p style="font-weight: bold;">收款方:</p>
															<p>开户名：{{ scope.row.collect_info.name }}</p>
															<p>开户行：{{ scope.row.collect_info.bankcard_branch_name }}</p>
															<p>账&nbsp;&nbsp;&nbsp;号：{{ scope.row.collect_info.bank_card_account }}</p>
														</div>
														<p style="font-weight: bold;color: #409EFF;" slot="reference">收款方:&nbsp;{{
															scope.row.collect_name }}</p>
													</el-popover>
													<p style="font-weight: bold;" v-else>收款方:&nbsp;{{ scope.row.collect_name }}</p>
												</div>
												<div style="margin-top: 10px;">
													<el-popover placement="bottom" width="400" v-if="scope.row.refund_name != '--'"
														trigger="hover">
														<div class="yhLine">
															<p style="font-weight: bold;">退款方:</p>
															<p>开户名：{{ scope.row.refund_info.name }}</p>
															<p>开户行：{{ scope.row.refund_info.bankcard_branch_name }}</p>
															<p>账&nbsp;&nbsp;&nbsp;号：{{ scope.row.refund_info.bank_card_account }}</p>
														</div>
														<p style="font-weight: bold;color: #409EFF;" slot="reference">退款方:&nbsp;{{
															scope.row.refund_name }}</p>
													</el-popover>
													<p style="font-weight: bold;" v-else>退款方:&nbsp;{{ scope.row.refund_name }}</p>
												</div>
											</template>
										</el-table-column>
										<el-table-column prop="uid_txt" label="申请人" width="80">
										</el-table-column>
										<el-table-column prop="bank_num_id" label="关联流水" width="80">
											<template slot-scope="scope">
												<el-popover placement="top" width="630" v-if="scope.row.bank_num_id_list.length > 0"
													trigger="hover">
													<el-table :data="scope.row.bank_num_id_list" style="width: 100%;" border stripe
														highlight-current-row>
														<el-table-column width="150" property="bank_num" label="银行流水号"></el-table-column>
														<el-table-column width="150" property="bank_name" label="银行名称"></el-table-column>
														<el-table-column width="150" property="bank_account" label="银行账户"></el-table-column>
														<el-table-column width="80" property="money" label="金额"></el-table-column>
														<el-table-column width="100" property="trade_date" label="交易日期"></el-table-column>
													</el-table>
													<span style="color: #409EFF;" slot="reference">查看详情</span>
												</el-popover>
												<span style="color: #409EFF;" v-else>--</span>
											</template>
										</el-table-column>
										<el-table-column prop="prove_attachment" label="退款凭证" width="80">
											<template slot-scope="scope">
												<el-link type="primary" :href="scope.row.prove_attachment" target="_blank"
													v-if="scope.row.prove_attachment" style="font-size: 12px;">预览</el-link>
												<template v-else>暂无</template>
											</template>
										</el-table-column>
										<el-table-column prop="remark" label="备注" min-width="200">
										</el-table-column>
										<el-table-column prop="refund_date" label="退款日期" width="100">
										</el-table-column>
										<!-- <el-table-column prop="refund_date" label="实际退款时间" width="100">
										</el-table-column> -->
										<el-table-column prop="create_time" label="申请日期" width="150">
										</el-table-column>
										<el-table-column fixed="right" prop="status_txt" label="状态" width="80">
											<template slot-scope="scope">
												<span style="font-weight: bold;">{{ scope.row.status_txt }}</span>
											</template>
										</el-table-column>
										<el-table-column fixed="right" label="操作"
											v-if="$parent.$parent.isAuthAction('admin/customers/customer/submitrefundrequest') || $parent.$parent.isAuthAction('admin/news/message/delcollectioninfo') || $parent.$parent.isAuthAction('admin/customers/customer/writeoffrefund') || $parent.$parent.isAuthAction('admin/customers/customer/confirmoff') || $parent.$parent.isAuthAction('admin/customers/customer/returnoff')"
											min-width="180">
											<template slot-scope="scope">
												<el-button :disabled="!(scope.row.status == 1)" @click="addConfirmForm(scope.row)" type="text"
													:size="size"
													v-if="$parent.$parent.isAuthAction('admin/customers/customer/submitrefundrequest')">提交审批</el-button>
												<el-button :disabled="!(scope.row.status == 1 || scope.row.status == 3)" type="text"
													@click="handleDelete(scope.row)" :size="size"
													v-if="$parent.$parent.isAuthAction('admin/news/message/delcollectioninfo')">删除申请</el-button>
												<el-button :disabled="!(scope.row.status == 4 && scope.row.balance > 0)" type="text"
													@click="handleWriteOffOpen(scope.row)" :size="size"
													v-if="$parent.$parent.isAuthAction('admin/customers/customer/writeoffrefund') && scope.row.refund_method == 2 && scope.row.off_status == 0">核销申请</el-button>
												<el-button :disabled="!(scope.row.status == 4 && scope.row.balance > 0)" type="text"
													@click="handleConfirmOffOpen(scope.row, 'queren')" :size="size"
													v-if="$parent.$parent.isAuthAction('admin/customers/customer/confirmoff') && scope.row.refund_method == 2 && scope.row.off_status == 1">核销确认</el-button>
												<el-button :disabled="!(scope.row.status == 4 && scope.row.balance > 0)" type="text"
													@click="handleConfirmOffOpen(scope.row, 'bohui')" :size="size"
													v-if="$parent.$parent.isAuthAction('admin/customers/customer/returnoff') && scope.row.refund_method == 2 && scope.row.off_status == 1">核销驳回</el-button>
											</template>
										</el-table-column>
									</el-table>
									<el-pagination background ref="pagination" @size-change="handleSizeChange"
										@current-change="handleCurrentChange" :current-page="tableData.page | number"
										:page-size="tableData.pagesize | number" :page-sizes="[15, 30, 50, 100]"
										layout="prev, pager, next, sizes, total" :total="tableData.total | number">
									</el-pagination>
								</template>
								<template v-if="turntypeName == 'second'">
									<el-table :key="2" :data="tableData2.data" style="width: 100%" border stripe ref="table2"
										v-loading="loading" highlight-current-row @sort-change="sortChange2" :height="tableHeight">
										<el-table-column prop="id" fixed label="ID" align="center" width="55">
										</el-table-column>
										<el-table-column prop="refund_code" label="退款编码" fixed width="210">
											<template slot-scope="scope">
												<el-link type="primary" style="font-size: 12px; text-decoration: underline;" :underline="false"
													@click="detail2(scope.row)" target="_blank">{{ scope.row.refund_code }}</el-link>
											</template>
										</el-table-column>
										<el-table-column prop="project_code" label="项目编码" width="160">
										</el-table-column>
										<el-table-column prop="type_txt" label="退款类型" width="80">
										</el-table-column>
										<el-table-column prop="refund_method_txt" label="退款账户" width="80">
										</el-table-column>
										<el-table-column prop="plarfotm_order" label="收款/退款详情" width="400" show-overflow-tooltip>
											<template slot-scope="scope">
												<div>
													<el-popover placement="top" width="400" v-if="scope.row.collect_name != '--'" trigger="hover">
														<div class="yhLine">
															<p style="font-weight: bold;">收款方:</p>
															<p>开户名：{{ scope.row.collect_info.name }}</p>
															<p>开户行：{{ scope.row.collect_info.bankcard_branch_name }}</p>
															<p>账&nbsp;&nbsp;&nbsp;号：{{ scope.row.collect_info.bank_card_account }}</p>
														</div>
														<p style="font-weight: bold;color: #409EFF;" slot="reference">收款方:&nbsp;{{
															scope.row.collect_name }}</p>
													</el-popover>
													<p style="font-weight: bold;" v-else>收款方:&nbsp;{{ scope.row.collect_name }}</p>
												</div>
												<div style="margin-top: 10px;">
													<el-popover placement="bottom" width="400" v-if="scope.row.refund_name != '--'"
														trigger="hover">
														<div class="yhLine">
															<p style="font-weight: bold;">退款方:</p>
															<p>开户名：{{ scope.row.refund_info.name }}</p>
															<p>开户行：{{ scope.row.refund_info.bankcard_branch_name }}</p>
															<p>账&nbsp;&nbsp;&nbsp;号：{{ scope.row.refund_info.bank_card_account }}</p>
														</div>
														<p style="font-weight: bold;color: #409EFF;" slot="reference">退款方:&nbsp;{{
															scope.row.refund_name }}</p>
													</el-popover>
													<p style="font-weight: bold;" v-else>退款方:&nbsp;{{ scope.row.refund_name }}</p>
												</div>
											</template>
										</el-table-column>
										<el-table-column prop="amount" label="退款金额" width="100">
										</el-table-column>
										<el-table-column prop="uid_txt" label="申请人" width="80">
										</el-table-column>
										<el-table-column prop="bank_num_id" label="关联流水" width="80">
											<template slot-scope="scope">
												<el-popover placement="top-start" width="630" v-if="scope.row.bank_num_id_list.length > 0"
													trigger="hover">
													<el-table :data="scope.row.bank_num_id_list" style="width: 100%;" border stripe
														highlight-current-row>
														<el-table-column width="150" property="bank_num" label="银行流水号"></el-table-column>
														<el-table-column width="150" property="bank_name" label="银行名称"></el-table-column>
														<el-table-column width="150" property="bank_account" label="银行账户"></el-table-column>
														<el-table-column width="80" property="money" label="金额"></el-table-column>
														<el-table-column width="100" property="trade_date" label="交易日期"></el-table-column>
													</el-table>
													<span style="color: #409EFF;" slot="reference">查看详情</span>
												</el-popover>
												<span style="color: #409EFF;" v-else>--</span>
											</template>
										</el-table-column>
										<el-table-column prop="prove_attachment" label="退款凭证" width="80">
											<template slot-scope="scope">
												<el-link type="primary" :href="scope.row.prove_attachment" target="_blank"
													v-if="scope.row.prove_attachment" style="font-size: 12px;">预览</el-link>
												<template v-else>暂无</template>
											</template>
										</el-table-column>
										<el-table-column prop="remark" label="备注" min-width="200">
										</el-table-column>
										<el-table-column prop="refund_date" label="退款日期" width="100">
										</el-table-column>
										<el-table-column prop="create_time" label="申请日期" width="150">
										</el-table-column>
										<el-table-column fixed="right" prop="status_txt" align="center" label="状态" width="80">
											<template slot-scope="scope">
												<span style="font-weight: bold;">{{ scope.row.status_txt }}</span>
											</template>
										</el-table-column>
										<el-table-column fixed="right" label="操作"
											v-if="$parent.$parent.isAuthAction('admin/custoemrs/customer/submitcustomerrefund') || $parent.$parent.isAuthAction('admin/customers/customer/delcustomerrefund')"
											min-width="150">
											<template slot-scope="scope">
												<el-button :disabled="!(scope.row.status == 1)" @click="addConfirmFormKh(scope.row)" type="text"
													:size="size"
													v-if="$parent.$parent.isAuthAction('admin/custoemrs/customer/submitcustomerrefund')">提交审批</el-button>
												<el-button :disabled="!(scope.row.status == 1 || scope.row.status == 3)" type="text"
													@click="handleDeleteKh(scope.row)" :size="size"
													v-if="$parent.$parent.isAuthAction('admin/customers/customer/delcustomerrefund')">删除申请</el-button>
											</template>
										</el-table-column>
									</el-table>
									<el-pagination background ref="pagination" @size-change="handleSizeChange2"
										@current-change="handleCurrentChange2" :current-page="tableData2.page | number"
										:page-size="tableData2.pagesize | number" :page-sizes="[15, 30, 50, 100]"
										layout="prev, pager, next, sizes, total" :total="tableData2.total | number">
									</el-pagination>
								</template>
							</div>
						</div>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
		<el-drawer custom-class="k-drawer" :visible.sync="turnFormVisiable" direction="rtl" :close-on-press-escape='false'
			:wrapperClosable='false' size="70%">
			<el-form :model="turnForm" ref="turnForm" :size="size" :rules="rules.turnForm" label-width="110px"
				v-loading="loading">
				<div class="drawer-header">
					<div class="header-title">
						<span>退款申请</span>
						<i class="el-icon-close k-drawer-close" @click="turnFormVisiable = false"></i>
					</div>
				</div>
				<div class="drawer-content">
					<el-form-item label="退款类型" prop="type">
						<el-radio-group v-model="turnForm.type" @input="getSelect()">
							<el-radio :label="1">供应商退款</el-radio>
							<el-radio :label="2">平台退款</el-radio>
							<el-radio :label="3">客户退款</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="执行明细" prop="execute_id" v-if="turnForm.type == 1 || turnForm.type == 2">
						<el-select v-model="turnForm.execute_id" filterable remote placeholder="请搜索执行编码" style="width: 100%;"
							@change="executeChange" :remote-method="getExecuteSelect">
							<el-option v-for="item in options.execute_id_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<div class="top" v-if="turnForm.execute_id">
						<el-row>
							<el-col :span="12">
								执行编码:{{ turnData.execute_code }}
							</el-col>
							<el-col :span="12">
								项目名称:{{ turnData.project_name }}
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								是否走平台:{{ turnData.is_plarfotm_order }}
							</el-col>
							<el-col :span="12">
								所属平台:{{ turnData.platform_name }}
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								资源名称:{{ turnData.resource_name }}
							</el-col>
							<el-col :span="12">
								平台单号: {{ turnData.plarfotm_order }}
							</el-col>
						</el-row>
					</div>
					<el-form-item v-if="turnForm.type == 2">
						<el-input v-model="turnForm.plarfotm_order" placeholder="请填写平台单号" clearable>
						</el-input>
					</el-form-item>
					<el-form-item label="客户" prop="customer_id" v-if="turnForm.type == 3">
						<el-select v-model="turnForm.customer_id" filterable remote clearable placeholder="请输入您要搜索的客户名称"
							style='width: 100%;' @change="getProjectlist()" :remote-method="getCustomer">
							<el-option v-for="item in options.customer_id_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="项目" prop="project_ids" v-if="turnForm.customer_id && turnForm.type == 3">
						<el-select v-model="turnForm.project_ids" filterable remote clearable placeholder="请输入您要搜索的项目名称"
							style='width: 100%;' @change="executeChange()" :remote-method="getProjectlist">
							<el-option v-for="item in options.project_ids_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="是否取消执行" prop="is_cancel_execute" v-if="turnForm.type == 1 || turnForm.type == 2">
						<el-radio-group v-model="turnForm.is_cancel_execute">
							<el-radio :label="1" style="display: block; margin:10px 0;">是，不再执行。(操作后执行明细状态为已取消/已作废)</el-radio>
							<el-radio :label="2" style="display: block; margin:10px 0;">否，继续执行。(操作后执行明细状态不变，仅是退款)</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="退款账户" prop="refund_bank_id" v-if="turnForm.type == 1 || turnForm.type == 3">
						<el-select v-model="turnForm.refund_bank_id" filterable placeholder="请选择退款账户" clearable
							style="width: 100%;">
							<el-option v-for="item in options.refund_bank_id_options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="收款账户" prop="collect_bank_id" v-if="turnForm.type == 1 || turnForm.type == 3">
						<el-select v-model="turnForm.collect_bank_id" filterable placeholder="请选择收款账户" clearable
							style="width: 100%;">
							<el-option v-for="item in options.collect_bank_id_options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="退款金额" prop="refund_price" v-if="turnForm.execute_id || turnForm.project_ids">
						<div style="display: flex;">
							<div style="width: 220px; margin-right: 10px;">
								<el-input v-model="turnForm.refund_price" placeholder="请填写退款金额" clearable></el-input>
							</div>
							<span style="color: #F56C6C;">(可退款金额：{{ turnData.use_refund_price }})</span>
						</div>
					</el-form-item>
					<el-form-item label="退款日期" prop="refund_date">
						<el-date-picker v-model="turnForm.refund_date" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
							placeholder="选择日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="退款凭证" prop="prove_attachment">
						<el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="turnForm.prove_attachment"
							:on-remove="(file) => handleRemoveUpload(file, 'turnForm', 'prove_attachment', true)" :auto-upload="false"
							:on-change="(file) => changeRequired(file, 'turnForm', 'prove_attachment', true)" :on-preview="viewImg">
							<el-button slot="trigger" size="mini">选取文件</el-button>
							<span style="margin-left: 10px; cursor: pointer;">
								<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式" placement="bottom-start">
									<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
								</el-tooltip>
							</span>
						</el-upload>
					</el-form-item>
					<el-form-item label="退款原因" prop="refund_reason">
						<el-input type="textarea" v-model="turnForm.refund_reason" placeholder="请填写退款原因" clearable maxlength="100"
							show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="退款账户" v-if="turnForm.type == 1">
						<el-radio-group v-model="turnForm.refund_method" @input="getBankstament">
							<el-radio :label="2">系统账户</el-radio>
							<el-radio :label="1">银行账户</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="银行流水" prop="bank_num_id" v-if="turnForm.refund_method == 1">
						<el-select v-model="turnForm.bank_num_id" filterable placeholder="请选择银行流水" clearable style="width: 100%;"
							remote :remote-method="getBankNum">
							<el-option v-for="item in options.bank_num_id_options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="申请备注">
						<el-input type="textarea" v-model="turnForm.remark" placeholder="请填写申请备注" clearable maxlength="100"
							show-word-limit></el-input>
					</el-form-item>
				</div>
				<div class="drawer-footer">
					<el-button type="primary" @click="addTurn" :size='size' :disabled="refundSubmitDisabled">提交</el-button>
					<el-button :size='size' @click="turnFormVisiable = false">取消</el-button>
				</div>
			</el-form>
		</el-drawer>
		<!-- 线下核销 -->
		<el-dialog title="线下核销" v-loading="loading" :visible.sync="linkVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" width="50%">
			<el-form :model="linkForm" ref="linkForm" :size="size" :rules="rules.linkForm" label-width="110px">
				<div>
					<el-form-item>
						<p style="font-weight: bold;">本次退款申请线下核销的金额为&nbsp;&nbsp;<span style="color: #F56C6C;">{{ linkForm.balance
								}}</span>&nbsp;&nbsp;元，请认真核对！</p>
					</el-form-item>
					<el-form-item label="核销凭证" prop="img">
						<el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="linkForm.img"
							:on-remove="file => handleRemoveUpload(file, 'linkForm', 'img', false)" :auto-upload="false"
							:on-change="file => changeRequired(file, 'linkForm', 'img', false)">
							<el-button slot="trigger" size="mini">选取文件</el-button>
							<span style="margin-left: 10px; cursor: pointer">
								<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式" placement="bottom-start">
									<i class="el-icon-warning-outline" style="padding: 0 6px; color: #cccccc !important"></i>
								</el-tooltip>
							</span>
						</el-upload>
					</el-form-item>
					<el-form-item label="填写备注" prop="textarea">
						<el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="linkForm.textarea">
						</el-input>
					</el-form-item>

				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="linkVisible = false" :size="size">取 消</el-button>
				<el-button type="primary" @click="addLink('linkForm')" :size="size">申 请</el-button>
			</span>
		</el-dialog>
		<el-dialog title="核销确认" center :visible.sync="dialogFormquerenVisible" width="50%">
			<el-form :model="querenForm" ref="querenForm" :size="size" :rules="rules.querenForm" label-width="100px">
				<el-form-item>
					<p style="color: red;font-size: 14px;">提示：是否确认线下核销退款申请({{ querenForm.refund_code }})的 {{
						querenForm.balance_txt }}
						元?
					</p>
				</el-form-item>
				<el-form-item label="银行流水" prop="bank_num_id" style="margin-top:20px;">
					<el-select multiple v-model="querenForm.bank_num_id" filterable placeholder="请选择银行流水" clearable
						style="width: 100%;" remote :remote-method="getBankNum" @change="checkShengyuCost">
						<el-option v-for="item in options.bank_num_id_options" :key="item.value" :label="item.label"
							:value="item.value" :disabled="item['disabled']">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button :size="size" @click="dialogFormquerenVisible = false">取 消</el-button>
				<el-button :size="size" type="primary" @click="querenhexiao('querenForm')">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="dialogVisibleImg">
			<img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
	</div>
</template>
<script>
export default {
	props: ['info'],
	data () {
		return {
			isDownloading: false,
			dialogFormquerenVisible: false,
			turnFormVisiable: false,
			refundSubmitDisabled: false,
			linkVisible: false,
			dialogVisibleImg: false,
			dialogImageUrl: '',
			activeName: 'first',
			turntypeName: 'first',
			loading: false,
			size: 'mini',
			querenForm: {
				id: '',
				refund_code: 0,
				balance_txt: '',
				bank_num_id: []
			},
			linkForm: {
				id: '',
				refund_method: 1,
				balance: 0,
				// bank_num_id: '',
				img: [],
				textarea: ''
			},
			pickerOptions: {
				disabledDate (time) {
					// 获取今天的日期
					const today = new Date();
					today.setHours(0, 0, 0, 0); // 设置时间为00:00:00:000
					return time.getTime() < today.getTime(); // 禁用今天之前的日期
				}
			},
			options: {
				execute_code_options: [],
				platform_id_options: [],
				refund_bank_id_options: [],
				collect_bank_id_options: [],
				bank_num_id_options: [],
				status_options: [
					{
						value: 1,
						label: '待提交'
					}, {
						value: 2,
						label: '待审核'
					}, {
						value: 3,
						label: '被驳回'
					}, {
						value: 4,
						label: '正常'
					}
				],
				customer_id_options: [],
				project_ids_options: []
			},
			searchForm: {
				off_status: '',
				refund_code: '',
				execute_code: '',
				plarfotm_order: '',
				dikou_type: '',
				project_code: '',
				refund_type: '',
				refund_method: '',
				refund_date: '',
				status: '',
				create_time: ''
			},
			resetSearch: {
				off_status: '',
				refund_code: '',
				execute_code: '',
				plarfotm_order: '',
				dikou_type: '',
				project_code: '',
				refund_type: '',
				refund_method: '',
				refund_date: '',
				status: '',
				create_time: ''
			},
			turnForm: {
				execute_id: '',
				refund_method: 2,
				type: 1,
				is_cancel_execute: 2,
				plarfotm_order: '',
				refund_bank_id: '',
				collect_bank_id: '',
				prove_attachment: [],
				refund_date: '',
				refund_price: '',
				refund_reason: '',
				remark: '',
				customer_id: '',
				project_ids: '',
				bank_num_id: ''
			},
			turnData: {
				execute_code: '',
				project_name: '',
				resource_name: '',
				platform_name: '',
				is_plarfotm_order: '',
				refund_price: ''
			},
			rules: {
				querenForm: {
					'bank_num_id': [
						{ required: true, message: '请选择银行流水', trigger: ['change'] }
					]
				},
				linkForm: {
					'img': [
						{ type: 'array', required: true, message: '请至少上传一个凭证', trigger: 'change' }
					],
					'textarea': [
						{ required: true, message: '请填写备注', trigger: 'blur' }
					]
				},
				turnForm: {
					'execute_id': [
						{ required: true, message: '请选择执行', trigger: ['change'] }
					],
					'type': [
						{ required: true, message: '请选择退款类型', trigger: ['change'] }
					],
					'is_cancel_execute': [
						{ required: true, message: '请选择是否取消执行', trigger: ['change'] }
					],
					'refund_bank_id': [
						{ required: true, message: '请选择退款方银行账号', trigger: ['change'] }
					],
					'project_ids': [
						{ required: true, message: '请选择项目', trigger: ['change'] }
					],
					'customer_id': [
						{ required: true, message: '请选择客户', trigger: ['change'] }
					],
					'collect_bank_id': [
						{ required: true, message: '请选择收款方银行账号', trigger: ['change'] }
					],
					'bank_num_id': [
						{ required: true, message: '请选择银行流水', trigger: ['change'] }
					],
					'prove_attachment': [
						{
							required: true, validator: (rule, value, callback) => {
								if (this.turnForm.prove_attachment.length < 1) {
									callback(new Error('请上传退款凭证'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					],
					'refund_price': [
						{
							required: true, validator: (rule, value, callback) => {
								if (!value) {
									callback(new Error('请填写退款金额'));
								} else if (value && value > Number(this.turnData.use_refund_price)) {
									callback(new Error('退款金额不可大于可退款金额！'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					],
					'refund_date': [
						{ required: true, message: '请选择退款日期', trigger: ['change'] }
					],
					'refund_reason': [
						{ required: true, message: '请填写退款原因', trigger: ['blur'] }
					]
				}
			},
			tableData: {
				total: 0,
				pagesize: 15,
				page: 1,
				data: []
			},
			tableData2: {
				total: 0,
				pagesize: 15,
				page: 1,
				data: []
			}
		}
	},
	computed: {
		isSupper: function () {
			return this.info.views.isSupper
		},
		tableHeight: function () {
			return window.innerHeight - 320;
		}
	},
	watch: {
	},
	mounted: function () {
		this.getPlateform()
		//this.handleSearch(this.searchForm);
	},
	methods: {
		checkShengyuCost (values) {
			if (values.length > 0) {
				// 勾选的发票总和
				let totalCost = this.options.bank_num_id_options.filter(record => values.indexOf(record.value) != -1).reduce((sum, record) => sum + Number(record.shengyu_cost), 0)
				// 核销总金额
				let ccost = this.querenForm.balance_txt * 100
				if (totalCost >= ccost) {
					this.options.bank_num_id_options.forEach((item, index) => {
						if (values.indexOf(item.value) != -1) {
							this.$set(this.options.bank_num_id_options[index], 'disabled', false)
						} else {
							this.$set(this.options.bank_num_id_options[index], 'disabled', true)
						}
					})
				} else {
					this.options.bank_num_id_options.forEach((item, index) => {
						this.$set(this.options.bank_num_id_options[index], 'disabled', false)
					})
				}
			} else {
				this.options.bank_num_id_options.forEach((item, index) => {
					this.$set(this.options.bank_num_id_options[index], 'disabled', false)
				})
			}
		},
		// 下载excel数据
		exportData () {
			this.isDownloading = true;
			var excelSearch = JSON.parse(JSON.stringify(this.searchForm))
			excelSearch.downloadType = 'refund'
			this.$api.get('/admin/customers/export/exportrefundexcel', excelSearch).then(res => {
				if (res.code == 0) {
					this.$alert('异步下载任务【退款申请列表下载】创建成功！请稍后查看下载列表', '下载提示', {
						confirmButtonText: '确定',
					});
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					});
				}
				this.isDownloading = false;
			})
		},
		getBankstament (val) {
			if (val == 1) {
				this.getBankNum()
			}
		},
		querenhexiao (formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.$api.get('/admin/customers/customer/confirmoff', this.querenForm).then(res => {
						if (res.code === 0) {
							this.$message({
								showClose: true,
								message: '核销成功',
								type: 'success'
							});
							this.handleSearch(this.searchForm)
						} else {
							this.$message.error(res.msg);
						}
						this.dialogFormquerenVisible = false
					})
				}
			})
		},
		handleConfirmOffOpen (row, type) {
			if (type == 'queren') {
				this.dialogFormquerenVisible = true
				this.querenForm.id = row.id
				this.querenForm.refund_code = row.refund_code
				this.querenForm.balance_txt = row.balance_txt
				this.querenForm.bank_num_id = []
				this.getBankNum()
			} else {
				var txt = '驳回'
				this.$confirm(this.$createElement('div', [
					this.$createElement('p', null, `是否${txt}线下核销退款申请(${row.refund_code})的 ${row.balance_txt} 元?`),
				]), '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(function () {
					this.$api.get('/admin/customers/customer/returnoff', { id: row.id }).then(res => {
						if (res.code === 0) {
							this.$message({
								showClose: true,
								message: '驳回成功',
								type: 'success'
							});
							this.handleSearch(this.searchForm)
						} else {
							this.$message.error(res.msg);
						}
					})
				}.bind(this))
			}
		},
		addLink (formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					const formData = new FormData()
					for (const key in this.linkForm) {
						if (key == 'img') {
							if (this.linkForm[key].length > 0) {
								this.linkForm[key].forEach(item => {
									formData.append(key, item)
								})
							}
						} else {
							formData.append(key, this.linkForm[key])
						}
					}
					this.$api.post('/admin/customers/customer/writeoffrefund', formData).then(res => {
						if (res.code === 0) {
							this.$message({
								showClose: true,
								message: '核销申请完成',
								type: 'success'
							});
							this.linkVisible = false
							this.handleSearch(this.searchForm)
						} else {
							this.$message.error(res.msg);
						}
					})
				}
			})
		},
		//上传图片
		changeRequired (file, formobj, field, limitOne = true) {
			if (limitOne) {
				this[formobj][field] = [file.raw]
			} else {
				this[formobj][field].push(file.raw)
			}
		},
		//移除图片
		handleRemoveUpload (file, formobj, field, limitOne = true) {
			if (limitOne) {
				this[formobj][field] = []
			} else {
				this[formobj][field].forEach(
					function (item, index) {
						if (item.name == file.name) {
							this.$delete(this[formobj][field], index)
						}
					}.bind(this)
				)
			}
		},
		handleWriteOffOpen (row) {
			this.linkForm.balance = row.balance_txt
			this.linkForm.refund_method = row.refund_method
			this.linkForm.id = row.id
			this.linkVisible = true
			this.getBankNum()
		},
		getPlateform () {
			this.$api.get('/admin/resources/resources/platformdwn').then(res => {
				if (res.code === 0) {
					this.options.platform_id_options = res.data
				}
			})
		},
		handleSizeChange2 (pages) {
			this.tableData2.pagesize = pages
			this.handleSearch2(this.searchForm, 1);
		},
		handleSizeChange (pages) {
			this.tableData.pagesize = pages
			this.handleSearch(this.searchForm, 1);
		},
		isColor (text) {
			if (text.includes('上升')) {
				return '#67C23A'
			} else if (text.includes('下降')) {
				return '#F56C6C'
			} else {
				return '#606266'
			}
		},
		isUp (val) {
			if (val.includes('上升')) {
				return val.replace("上升", "↑")
			} else if (val.includes('下降')) {
				return val.replace("下降", "↓")
			} else {
				return val
			}
		},
		handleSearch: function (params, page, prop, order) {
			this.loading = true;
			var param = Object.assign({}, params);
			param['page'] = page ? page : 1;
			param['pagesize'] = this.tableData.pagesize;
			param['prop'] = prop ? prop : 'id';
			param['order'] = order ? order : 'desc';
			this.$api.get('/admin/customers/customer/refundrequestlist', param).then(res => {
				if (res.code === 0) {
					this.tableData = res.data;
					this.$nextTick(() => {
						if (this.$refs.table1) {
							this.$refs.table1.doLayout();
						}
					});
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		handleSearch2: function (params, page, prop, order) {
			this.loading = true;
			var param = Object.assign({}, params);
			param['page'] = page ? page : 1;
			param['pagesize'] = this.tableData2.pagesize;
			param['prop'] = prop ? prop : 'id';
			param['order'] = order ? order : 'desc';
			this.$api.get('/admin/customers/customer/refundcustomerrequestlist', param).then(res => {
				if (res.code === 0) {
					this.tableData2 = res.data;
					this.$nextTick(() => {
						if (this.$refs.table2) {
							this.$refs.table2.doLayout();
						}
					});
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		// 执行查询
		doSearch () {
			this.handleSearch(this.searchForm)
		},
		// 重置
		reset () {
			this.searchForm = JSON.parse(JSON.stringify(this.resetSearch));
			this.doSearch();
		},
		// 排序
		sortChange (e) {
			var order;
			var prop = e.prop;
			if (e.order == 'ascending') {
				order = 'asc';
			} else if (e.order == 'descending') {
				order = 'desc';
			} else {
				prop = this.resetSearch.prop;
				order = this.resetSearch.order;
			}
			this.handleSearch(this.searchForm, 1, prop, order);
		},
		// 排序
		sortChange2 (e) {
			var order;
			var prop = e.prop;
			if (e.order == 'ascending') {
				order = 'asc';
			} else if (e.order == 'descending') {
				order = 'desc';
			} else {
				prop = this.resetSearch.prop;
				order = this.resetSearch.order;
			}
			this.handleSearch2(this.searchForm, 1, prop, order);
		},
		// 改变当前页 page
		handleCurrentChange (val) {
			this.handleSearch(this.searchForm, val);
		},
		// 改变当前页 page
		handleCurrentChange2 (val) {
			this.handleSearch2(this.searchForm, val);
		},
		//切换审核状态
		handleCheckClick (tab, event) {
			if (this.turntypeName == 'first') {
				this.handleSearch(this.searchForm)
				if (this.$refs.table1) {
					this.$refs.table1.doLayout();
				}
			} else if (this.turntypeName == 'second') {
				this.handleSearch2(this.searchForm)
				if (this.$refs.table2) {
					this.$refs.table2.doLayout();
				}
			}
		},
		//打开详情页
		detail (row) {
			this.$router.push({
				name: 'RefundDetail',
				query: { id: row.id, set_id: 16, type: 'detail' }
			});
		},
		//打开详情页
		detail2 (row) {
			this.$router.push({
				name: 'RefundDetail',
				query: { id: row.id, set_id: 18, type: 'detail' }
			});
		},
		handleTableFlow (row) {
			this.$api.post('/admin/customers/customer/submitprojectapproval', { project_id: row.id }).then(res => {
				if (res.code === 0) {
					var data = this.tableData.data;
					data.forEach(function (item, index) {
						if (row.id == item.id) {
							this.$set(data[index], 'status_txt', '待审核');
							this.$set(data[index], 'status', 2);
						}
					}.bind(this));
					this.$message({
						showClose: true,
						message: '该项目已进入审批流程，等待审核！',
						type: 'success'
					});
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		addTurnOpen () {
			this.turnForm = {
				execute_id: '',
				refund_method: 2,
				type: 1,
				is_cancel_execute: 2,
				plarfotm_order: '',
				refund_bank_id: '',
				collect_bank_id: '',
				prove_attachment: [],
				refund_date: '',
				refund_price: '',
				refund_reason: '',
				remark: '',
				customer_id: '',
				project_ids: '',
				bank_num_id: ''
			}
			this.turnData = {
				execute_code: '',
				project_name: '',
				resource_name: '',
				platform_name: '',
				is_plarfotm_order: '',
				refund_price: ''
			}
			this.$nextTick(() => {
				this.$refs['turnForm'].clearValidate();
			});
			this.turnFormVisiable = true
			this.getSelect()
		},
		getSelect () {
			this.turnForm.execute_id = ''
			this.turnForm.customer_id = ''
			this.turnForm.project_ids = ''
			this.turnForm.plarfotm_order = ''
			this.turnForm.refund_bank_id = ''
			this.turnForm.collect_bank_id = ''
			this.turnForm.refund_method = 2
			this.turnForm.bank_num_id = ''
			this.options.customer_id_options = []
			this.options.project_ids_options = []
			this.options.execute_id_options = []
			this.options.refund_bank_id_options = []
			this.options.collect_bank_id_options = []
			this.options.bank_num_id_options = []
			this.$nextTick(() => {
				this.$refs['turnForm'].clearValidate();
			});
			this.loading = true
			if (this.turnForm.type == 1 || this.turnForm.type == 2) {
				this.getExecuteSelect()
			} else if (this.turnForm.type == 3) {
				this.getCustomer()
			}
		},
		getExecuteSelect (query) {
			query = query ? query : ''
			this.$api.get('/admin/customers/customer/getexecuteselect', { refund_type: this.turnForm.type, "query": query }).then(res => {
				if (res.code == 0) {
					this.options.execute_id_options = res.data
					this.$forceUpdate();
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		executeChange () {
			this.$api.get('/admin/customers/customer/projectinforefundprice', { execute_id: this.turnForm.execute_id, project_id: this.turnForm.project_ids, refund_type: this.turnForm.type }).then(res => {
				if (res.code === 0) {
					this.turnData = res.data
					this.turnForm.type = res.data.refund_type
					this.$set(this.turnForm, 'refund_price', '')
					if (res.data.refund_type == 1 || res.data.refund_type == 3) {
						this.getBank()
					}
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		getBank () {
			this.$api.get('/admin/customers/customer/refundbankcardlist', { execute_id: this.turnForm.execute_id, refund_type: this.turnForm.type }).then(res => {
				if (res.code === 0) {
					this.options.refund_bank_id_options = res.data
				}
			})
			this.$api.get('/admin/customers/customer/collectbankcardlist', { execute_id: this.turnForm.execute_id, project_id: this.turnForm.project_ids, refund_type: this.turnForm.type }).then(res => {
				if (res.code === 0) {
					this.options.collect_bank_id_options = res.data
				}
			})
		},
		getBankNum (query) {
			query = query ? query : ''
			this.$api.get('/admin/customers/customer/getbanklineselect', { type: "0,3", nature: "0,5", 'query': query }).then(res => {
				if (res.code === 0) {
					this.options.bank_num_id_options = res.data
				}
			})
		},
		addTurn () {
			if (this.refundSubmitDisabled) return;
			const formData = new FormData()
			for (const key in this.turnForm) {
				if (key == 'prove_attachment') {
					if (this.turnForm[key].length > 0) {
						this.turnForm[key].forEach(item => {
							formData.append(key, item)
						})
					} else {
						formData.append(key, '')
					}
				} else {
					formData.append(key, this.turnForm[key]);
				}
			}
			this.$refs['turnForm'].validate(function (valid) {
				if (valid) {
					this.refundSubmitDisabled = true;
					this.$api.post('/admin/customers/customer/craterefundrequest', formData).then(res => {
						if (res.code === 0) {
							// 重新加载表格
							if (this.turntypeName == 'first') {
								this.handleSearch();
							} else if (this.turntypeName == 'second') {
								this.handleSearch2();
							}
							this.$message({
								showClose: true,
								message: '退款申请创建成功！',
								type: 'success'
							});
							this.turnFormVisiable = false;
						} else {
							this.$message.error(res.msg);
						}
						this.refundSubmitDisabled = false;
					}).catch(() => {
						this.refundSubmitDisabled = false;
					})
				}
			}.bind(this));
		},
		//点击查看大图
		viewImg (file) {
			if (!file.path) {
				//还未上传
				let url = URL.createObjectURL(file)
				if (file.name.includes('.pdf')) {
					window.open(url)
				} else {
					this.dialogImageUrl = url;
					this.dialogVisibleImg = true;
				}

			} else {
				//已上传
				if (file.name.includes('.pdf')) {
					window.open(file.path)
				} else {
					this.dialogImageUrl = file.path;
					this.dialogVisibleImg = true;
				}
			}
		},
		//上传图片
		changeRequired (file, formobj, field, limitOne = true) {
			if (limitOne) {
				this[formobj][field] = [file.raw]
			} else {
				this[formobj][field].push(file.raw)
			}
		},
		//移除图片
		handleRemoveUpload (file, formobj, field, limitOne = true) {
			if (limitOne) {
				this[formobj][field] = []
			} else {
				this[formobj][field].forEach(function (item, index) {
					if (item.name == file.name) {
						this.$delete(this[formobj][field], index)
					}
				}.bind(this))
			}
		},
		handleDelete (row) {
			this.$confirm('此操作将永久删除该条申请, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				this.loading = true;
				this.$api.delete('/admin/customers/customer/delrefundrequest', { id: row.id }).then(res => {
					if (res.code === 0) {
						var data = this.tableData.data;
						data.forEach(function (item, index) {
							if (item.id == row.id) {
								this.$delete(data, index);
							}
						}.bind(this));
						this.$message({
							showClose: true,
							message: '该申请已成功删除！',
							type: 'success'
						});
					} else {
						this.$message.error(res.msg);
					}
					this.loading = false
				})
			}.bind(this))
		},
		//客户退款删除申请
		handleDeleteKh (row) {
			this.$confirm('此操作将永久删除该条申请, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				this.loading = true;
				this.$api.delete('/admin/customers/customer/delcustomerrefund', { id: row.id }).then(res => {
					if (res.code === 0) {
						var data = this.tableData2.data;
						data.forEach(function (item, index) {
							if (item.id == row.id) {
								this.$delete(data, index);
							}
						}.bind(this));
						this.$message({
							showClose: true,
							message: '该申请已成功删除！',
							type: 'success'
						});
					} else {
						this.$message.error(res.msg);
					}
					this.loading = false
				})
			}.bind(this))
		},
		addConfirmForm (row) {
			this.$api.post('/admin/customers/customer/submitrefundrequest', { id: row.id }).then(res => {
				if (res.code === 0) {
					var data = this.tableData.data;
					data.forEach(function (item, index) {
						if (row.id == item.id) {
							this.$set(data[index], 'status_txt', '待审核');
							this.$set(data[index], 'status', 2);
						}
					}.bind(this));
					this.$message({
						showClose: true,
						message: '该申请已进入审批流程，等待审核！',
						type: 'success'
					});
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//客户退款提交审批
		addConfirmFormKh (row) {
			this.$api.post('/admin/customers/customer/submitcustomerrefund', { id: row.id }).then(res => {
				if (res.code === 0) {
					var data = this.tableData2.data;
					data.forEach(function (item, index) {
						if (row.id == item.id) {
							this.$set(data[index], 'status_txt', '待审核');
							this.$set(data[index], 'status', 2);
						}
					}.bind(this));
					this.$message({
						showClose: true,
						message: '该申请已进入审批流程，等待审核！',
						type: 'success'
					});
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//获取客户下拉
		getCustomer (query) {
			this.$api.get('/admin/customers/customer/getcustomerselect', { 'query': query }).then(res => {
				if (res.code === 0) {
					this.options.customer_id_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//选择客户后获取对应的项目下拉
		getProjectlist (query) {
			query = query ? query : ''
			this.turnForm.project_ids = ''
			this.options.project_ids_options = []
			this.$api.get('/admin/customers/customer/projectdwlist', { 'customer_id': this.turnForm.customer_id, 'query': query }).then(res => {
				if (res.code === 0) {
					this.options.project_ids_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			// 使用 === 进行严格相等判断
			if (from.path !== '/refundDetail') {
				try {
					vm.reset();
				} catch (error) {
				}
			}
		});
	}
}
</script>
<style type="text/css" scoped>
.el-table .el-form-item--mini.el-form-item,
.el-table .el-form-item--small.el-form-item {
	margin-bottom: 0;
}

.yhLine {
	line-height: 30px;
}

.kBill .title {
	border-bottom: none !important;
	color: #409EFF;
}

.top {
	line-height: 30px;
	font-size: 14px;
	color: #606266;
	border-bottom: 1px solid #DCDFE6;
	padding-bottom: 15px;
	margin-bottom: 15px;
	margin-left: 120px;
}

.resourceHandleTop {
	position: relative;
	padding-bottom: 20px;
	background-color: #fff;

	.btn {
		position: absolute;
		right: 100px;
		top: 0;
		height: 48px;
		display: flex;
		align-items: center;
	}

	.btn_d {
		position: absolute;
		right: 20px;
		top: 0;
		height: 48px;
		display: flex;
		align-items: center;
	}
}
</style>